<template>
	<div class="login-fragment">
		<div class="body">
			<div v-show="page == 'login'" class="window">
				<h1>Log ind</h1>
				<p>Indtast brugernavn og adgangskode for at logge ind.</p>
				<div class="line">
					<string-view type="email" placeholder="E-mail" v-model="credentials.username" autocorrect="off" autocapitalize="none" />
				</div>
				<div class="line">
					<string-view type="password" placeholder="Adgangskode" v-model="credentials.password" />
				</div>
				<button-view @click="login" style="display: block;">Log ind</button-view>
				<button-view class="gray" @click="goto('forgot')" style="display: block;">Glemt kode</button-view>
				<div class="error" v-show="error">{{ error }}</div>
			</div>
			<div v-show="page == 'forgot'" class="window">
				<h1>Glemt din kode?</h1>
				<p>Indtast din email adresse herunder, så sender vi dig en kode til at nulstille din adgangskode.</p>
				<div class="line">
					<string-view type="email" placeholder="E-mail" v-model="email" autocorrect="off" autocapitalize="none" />
				</div>
				<button-view @click="request" style="display: block;">Send</button-view>
				<button-view class="gray" @click="goto('login')" style="display: block;">Annuller</button-view>
				<div class="error" v-show="error">{{ error }}</div>
			</div>
			<div v-show="page == 'reset'" class="window">
				<h1>Opret ny adgangskode</h1>
				<p>Du skulle have modtaget en kode på din e-mail adresse, som du skal bruge til at kunne vælge en ny adgangskode.</p>
				<div class="line">
					<string-view type="email" placeholder="E-mail" v-model="username" autocorrect="off" autocapitalize="none" />
				</div>
				<div class="line">
					<string-view type="text" placeholder="Genoprettelseskode" v-model="code" autocorrect="off" autocapitalize="none" />
				</div>
				<div class="line">
					<string-view type="password" placeholder="Adgangskode" v-model="password" />
				</div>
				<button-view @click="reset" style="display: block;">Gem</button-view>
				<button-view class="gray" @click="goto('login')" style="display: block;">Annuller</button-view>
				<div class="error" v-show="error">{{ error }}</div>
			</div>
		</div>
		<div class="footer">
			<img style="width: 50%;" src="/images/moovr_logo_red_black.svg" alt="logo"><br>
			<br>
			<br>
			© 2018 - {{ (new Date()).getFullYear() }}, Spartan Software ApS
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				credentials: {
					username: '',
					password: '',
					customer_id: 1
				},
				code: '',
				customer_id: 1,
				email: '',
				password: '',
				username: '',
				page: 'login',
				error: null
			};
		},
		methods: {
			login() {
				console.log(this.credentials, this.axios);
				var self = this;

				this.axios.post('/token/', this.credentials).then(function (r) {
					console.log('success', r);
					self.$store.commit('auth', r.data);

					self.axios.get('/me/').then(function (r) {
						if (r.data.privileges.app_login) {
							self.$store.commit('user', r.data);

							self.$router.replace({
								name: 'calendar'
							});

							self.axios.get('/me/stamps/active/').then(function (r) {
								console.log(r.data);
								self.$store.commit('stamps', r.data);
							});
						} else {
							self.$store.commit('auth', null);
							self.error = 'Manglende rettigheder';
						}
					});
				}, function (err) {
					console.log('error', err);
					self.error = err.response.data.message;
				});
			},
			reset() {
				var self = this;

				this.axios.post('/reset/password/', {
					username: this.username,
					code: this.code,
					password: this.password,
					customer_id: 1
				}).then(function (r) {
					self.credentials.username = self.username;
					//alert('');
					self.goto('login');
				}, function (err) {
					console.log('error', err);
					self.error = 'Kunne ikke gemme adgangskoden, har du tastet korrekt brugernavn og genoprettelseskode?';
				});
			},
			request() {
				var self = this;

				this.axios.post('/reset/email/', {
					email: this.email,
					customer_id: 1
				}).then(function (r) {
					self.goto('reset');
				}, function (err) {
					console.log('error', err);
					self.error = 'Kunne ikke sende dig en kode, har du tastet den korrekte e-mail?';
				});
			},
			goto(page) {
				this.error = null;
				this.page = page;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login-fragment {
		background-size: cover;
		height: 100%;
		display: grid;
		grid-template-rows: 3fr 1fr;
		align-items: center;
		justify-items: center;

		& > .body {
			& > .window {
				margin: 0 10% 0 10%;

				& > .error {
					margin-top: 20px;
					text-align: center;
					color: #f7223f;
					line-height: 40px;
				}
			
				& > h1 {
					display: block;
					font-size: 2em;
					margin-block-start: 0.67em;
					margin-block-end: 0.67em;
					margin-inline-start: 0px;
					margin-inline-end: 0px;
					font-weight: bold;
				}

				& > p {
					display: block;
					margin-block-start: 1em;
					margin-block-end: 1em;
					margin-inline-start: 0px;
					margin-inline-end: 0px;
					margin-bottom: 40px;
					color: #969696;
				}

				& > .line {
					margin-bottom: 20px;

					& > input {
						-webkit-appearance: none;
						-moz-appearance: none;
						appearance: none;

						width: 100%;
						height: 40px;
						border: 1px solid #d1d1d1;
						outline: none;
					}
				}

				& > .gray {
					background-color: white;
					color: black;
					margin-top: 20px;
				}
			}
		}

		& > .footer {
			text-align: center;
			color: black;
		}
	}
</style>